import styled from "styled-components";

export const Card = styled.div`
  background-color: #f5f5f5;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  margin-top: 16px;
`;

export const FileInfoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px 20px;
`;

export const FileInfoName = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #333;
`;

export const FileInfoMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 13px;
  color: #666;
`;

export const Separator = styled.div`
  height: 1px;
  background-color: #e0e0e0;
  margin: 0;
`;

export const StatusSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin: 16px 20px 20px 20px;
  padding: 16px 20px;
  border-radius: 8px;
  background-color: ${({ variant }) => (variant === "error" ? "#FDEDED" : "#E8F5E9")};
  color: ${({ variant }) => (variant === "error" ? "#5F2120" : "#2E7D32")};

  .file-status-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    min-width: 40px;
    border-radius: 50%;
    color: ${({ variant }) => (variant === "error" ? "#D74141" : "#2e7e33")};
  }

  .file-status-message {
    flex: 1;
    font-size: 14px;
    line-height: 1.5;
    min-width: 200px;

    strong {
      font-weight: 700;
    }
  }

  .file-status-action {
    white-space: nowrap;
  }
`;